import { useState, useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState(false);
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [admin, setAdmin] = useState();

  const history = useHistory();

  const login = useCallback((currentAdmin, token, expirationDate) => {
    setToken(token);
    setAdmin(currentAdmin);
    const tokenExpirationDate =
      expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60 * 24); // 24h
    setTokenExpirationDate(tokenExpirationDate);
    localStorage.setItem(
      'userData',
      JSON.stringify({
        admin: currentAdmin,
        token: token,
        expiration: tokenExpirationDate.toISOString(),
      })
    );
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setAdmin(null);
    localStorage.removeItem('userData');
    history.push('/');
  }, [history]);

  const update = useCallback((updatedAdmin) => {
    setAdmin(updatedAdmin);
    const storedData = JSON.parse(localStorage.getItem('userData'));

    localStorage.setItem(
      'userData',
      JSON.stringify({
        ...storedData,
        admin: updatedAdmin,
      })
    );
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime =
        tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem('userData'));

    if (
      storedData &&
      storedData.token &&
      new Date(storedData.expiration) > new Date()
    ) {
      login(
        storedData.admin,
        storedData.token,
        new Date(storedData.expiration)
      );
    } else {
      setToken(null);
      setTokenExpirationDate(null);
      setAdmin(null);
      localStorage.removeItem('userData');
    }
  }, [login]);

  return { token, login, logout, admin, update };
};
